<template lang="pug">
  .criteria-wrap
    .criteria(
      v-for="({value, field, dataType}, i) in criteria", :key="i")
      .criteria__header
        label.title Filter {{i+1}}
        a.remove(v-if="criteria.length !== 1", @click="deleteCriteria(i)")
          i.el-icon-circle-close.icon
          |  Remove filter
      .criteria__body
        lei-filter(
          v-for="(params, index) in criteriaBase(i)"
          select
          :key="index"
          :dropdown-mode="params.dropdownMode"
          :class="params.className"
          :index="i"
          :items="params.items"
          :disabled="params.disabled"
          :initial-value="params.initialValue"
          :tip="params.tip"
          :chosenField="params.chosenField"
          :name="params.label"
          @choose="params.select"
          :get-label="params.getLabel"
        )
        input-creator(
          :key="field.field"
          :index="i"
          :data-type="dataType"
          :value="value"
          :disabled="field === ''"
          :filter="field"
          :label="searchLabel"
          root-class="search-input"
          :tip="tooltips.searchValue"
          @enter="enter"
          @set-enum-value="setEnumValue"
          @set-range-value="setRangeValue"
          @set-input-value="setInputValue"
        )
        a.remove.el-icon-circle-close(v-if="criteria.length !== 1", @click="deleteCriteria(i)")
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState, } from 'vuex'
import { REMOVE_CRITERIA, SET_CRITERIA, } from '@/store/modules/search/mutations-types'
import { getItemsByContext, findFilterById, } from '@/store/modules/search/helpers'
import { getInputType, } from '@/utils/criteria'
import { getLabelForOperators, } from '@/utils/operators'
import { EventBus, } from '@/event-bus'
import countries from '@/constants/countries'
import expert from '@/constants/tooltips/expert'
import routerSearch from '@/mixins/router-search-mixin'
import LeiFilter from '@/components/lei-components/inputs/LeiFilter'
import InputCreator from '@/components/lei-components/inputs/InputCreator'

export default {
  components: {
    InputCreator,
    LeiFilter,
  },
  mixins: [ routerSearch, ],
  props: {
    title: {
      type: String,
      default: 'LEI Search',
    },
    info: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      searchLabel: 'Search Value',
      countries,
      tooltips: expert,
      chosenField: [],
    }
  },
  computed: {
    ...mapState('search', [ 'filters', 'criteria', 'relationships', ]),
    ...mapGetters('search', [ 'getFields', ]),
  },
  mounted () {
    EventBus.$on('clear-list', () => {
      this.setChosenFields()
    })
    this.preselect()
    this.setChosenFields()
  },
  beforeDestroy () {
    EventBus.$off('clear-list')
  },
  methods: {
    enter () {
      this.$emit('enter')
    },
    getFieldsItems (fields, relationship) {
      return fields && fields.length !== 0 ? fields : this.getFields(relationship.id)
    },
    selectField ({ item, index, }) {
      this.chosenField[index] = item.id
      this.setCriteriaObject(index, {
        field: item,
        dataType: getInputType(item.data_type),
        value: '',
        operators: item.operators,
      })
      // console.log(this.criteria[index].enumItems)
      this.selectOperator({
        item: item.operators[0],
        index,
      })
    },
    selectRelationship ({ item, index, }) {
      // console.log(item.contexts)
      // console.log(getItemsByContext(this.filters, item.contexts))
      this.setCriteriaObject(index, {
        relationship: item,
        field: '',
        value: '',
        fields: getItemsByContext(this.filters, item.id),
        dataType: 'STRING',
        operator: '',
        operators: [],
      })
      this.setChosenFields()
    },
    selectOperator ({ item, index, }) {
      const currentFilter = this.criteria[index]
      const oldInputType = currentFilter.dataType
      const newInputType = getInputType(currentFilter.field.data_type, item)
      const oldValue = currentFilter.value
      const newValue = newInputType === 'NUMBER_RANGE' || newInputType === 'DATE_RANGE' ? [ '', '', ] : ''
      this.setCriteriaObject(index, {
        operator: item,
        dataType: newInputType,
        value: oldInputType === newInputType ? oldValue : newValue,
      })
    },
    setCriteriaObject (index, criteria) {
      this.setCriteria({
        index,
        criteria,
      })
    },
    setInputValue ({ value, index, }) {
      this.setCriteriaObject(index, { value, })
    },
    setRangeValue ({ value, position, index, }) {
      const oldValue = this.criteria[index].value
      const newValue = oldValue.map((item, index) => index === position ? value : item)
      this.setCriteriaObject(index, { value: newValue, })
    },
    setEnumValue ({ value, index, }) {
      this.setCriteriaObject(index, { value, })
    },
    deleteCriteria (index) {
      this.chosenField.splice(index, 1)
      this.removeCriteria(index)
    },
    setChosenFields () {
      this.chosenField = this.criteria.reduce((acc, { field, }) => field ? [ ...acc, field.id, ] : acc, [])
    },
    preselect () {
      const needPreselect = this.criteria[0].field === '' && this.criteria[0].value === ''
      if (needPreselect) this.selectField({
        item: findFilterById(this.filters, 'LEIREC_LEGAL_NAME'),
        index: 0,
      })
    },
    criteriaBase (index) {
      const { relationship, field, fields, operator, operators, } = this.criteria[index]
      return [
        {
          label: 'Relationship',
          className: 'relationships',
          dropdownMode: true,
          items: this.relationships,
          initialValue: relationship,
          tip: this.tooltips.relationship,
          getLabel: (item) => item.label,
          select: this.selectRelationship,
        },
        {
          label: 'LEI Data Field',
          className: 'fields',
          items: this.getFieldsItems(fields, relationship),
          initialValue: field,
          chosenField: this.chosenField,
          tip: this.tooltips.leiData,
          getLabel: (item) => item.label,
          select: this.selectField,
        },
        {
          label: 'Operators',
          className: 'operators',
          disabled: field === '',
          items: operators,
          initialValue: operator,
          tip: this.tooltips.operator,
          getLabel: getLabelForOperators,
          select: this.selectOperator,
        },
      ]
    },

    ...mapMutations('search', {
      removeCriteria: REMOVE_CRITERIA,
      setCriteria: SET_CRITERIA,
    }),
    ...mapActions('search', [ 'getResources', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  .criteria
    display flex
    position relative
    flex-direction column
    .lei-filter .filter-wrap
      min-width 200px
    &__header
      height 35px
      font-size 80%
      display flex
      justify-content space-between
      padding 10px 20px
      align-items center
      color $white-color
      background-color $default-color
      .title
        font-weight 700
      .remove
        font-weight 600
        display flex
        align-items center
        .icon
          margin-right 5px
          font-size 125%
        &:hover
          cursor pointer
          color $danger-color
    &__body
      display flex
      justify-content space-between

      .lei-filter:nth-child(4)
        margin-right 0

    .choice
      display inline-block
      align-items center
      line-height 1.5
    .flag
      width 20px
      position relative
      top 1px
      margin-right 10px
    .search-input
      display flex
    .lei-filter.select .button-wrap .category, .label, .datepicker-label
      padding 0

  @media screen and (max-width: $tablet)
    .criteria
      margin-bottom 20px
      &:last-child
        margin-bottom 0
      &__body
        flex-direction column
        .remove
          display none
      &__header
        display flex
      .name, .label, .datepicker-label
        min-width 90px

    .search-input
      border-bottom 1px solid $default-color-light-1
      &.date
        position relative
        .clear
          display none
      &.string, &.date, &.range
        height $input-sm
        padding 0 20px
        background-color $default-color-light-2
        width 100%
        align-items center
        flex-direction row
        .label, .datepicker-label
          color $default-color-bold
          font-size 0.75rem
          font-weight 500
        .input, .datepicker-input
          width auto
          flex 1
          font-size 0.75rem
          color $default-color-bold
          font-weight 600
          background-color transparent
          border none
          height 30px
          padding 5px 15px

        .input:disabled
          background-color transparent !important

  @media screen and (min-width: $laptop-min)
    .criteria
      &__body
        flex-direction row
        .remove
          bottom 34px
          transform translateY(50%)
          position absolute
          font-size 1.3rem
          right -2rem
          color $default-color-middle
          &:hover
            cursor pointer
            color $danger-color
      &__header
        display none
      .relationships, .fields, .operators, .search-input
        &.lei-filter.select .button-wrap .category, .label-tip-box, .datepicker-label-tip-box
          display none
      &:first-child
        .relationships, .fields, .operators, .search-input
          &.lei-filter.select .button-wrap .category, .label-tip-box, .datepicker-label-tip-box
            display inline-flex

      .label-tip-box, .filter-label-tip-box, .datepicker-label-tip-box
        margin-bottom 10px

    .relationships
      display flex
      flex 5

    .fields
      display flex
      flex 5

    .operators
      display flex
      flex 5

    .search-input
      display flex
      width 28%
      &.date
        position relative
        .clear
          display none
      &.string, &.date, &.range
        flex-direction column
        .label, .datepicker-label
          color $default-color-bold
          font-size 0.85rem
          font-weight 600
        .input, .datepicker-input
          width 100%
          font-size 1rem
          color $default-color-bold
          font-weight 500
          background-color $white-color
          border 1px solid $default-color
          height $input-md
          padding 15px 20px

  @media screen and (max-width: $laptop-l) and (min-width: $laptop-min)
    $local-font-size = .85rem
    .criteria
      .lei-filter.select
        &.search-input
          margin 0
        .button-wrap
          .select-block
            font-size  $local-font-size
            height $input-sm
            padding 5px 30px 5px 10px
    .criteria__body
        flex-direction row
        .remove
          bottom 29px

    .search-input
      &.string, &.date, &.range
        .label, .datepicker-label
          font-size  $local-font-size
        .input, .datepicker-input
          font-size $local-font-size
          height $input-sm
          padding 5px 10px

  @media screen and (max-width: $laptop) and (min-width: $laptop-min)
    $local-font-size = .85rem
    .criteria
      width calc(100% - 30px)
</style>



// WEBPACK FOOTER //
// src/components/search-components/Criteria.vue